
export const WaitingRoomScreen = () => `
        <div id="waiting-room-screen" class="screen">
            <div class="wr-layout">
                <!-- Header: Room INFO -->
                <div class="wr-header glass-panel">
                    <div class="wr-room-info">
                        <span class="label">ODA:</span>
                        <h1 id="display-room-id" aria-label="Oda Kodu">-----</h1>
                        <button id="copy-room-id-btn" class="gaddar-btn icon-only" title="Kopyala" aria-label="Oda Kodunu Kopyala">❐</button>
                        
                        <!-- [NEW] Chat Button -->
                        <button id="wr-chat-btn" class="gaddar-btn icon-only hidden" title="Sohbeti Aç" aria-label="Sohbeti Aç" style="margin-left: 5px; font-size: 1.2rem; background: linear-gradient(135deg, #3498db, #2980b9); border-color: #2980b9;">💬</button>
                        
                        <button id="open-accessibility-btn" class="gaddar-btn icon-only" title="Görünüm Ayarları" aria-label="Görünüm ve Erişilebilirlik Ayarları" style="margin-left: 5px; font-size: 1.1rem; font-weight: bold; font-family: sans-serif; background: linear-gradient(135deg, #27ae60, #2ecc71); border-color: #2ecc71;">Aa</button>
                    </div>

                    <div class="wr-status">
                        <!-- [NEW] Switch to Roulette Button (Host Only) -->
                        <button id="wr-switch-roulette-btn" class="gaddar-btn hidden" title="Gaddar Rulet Moduna Geç" style="margin-right: 10px; font-size: 0.75rem; font-weight: 800; background: linear-gradient(135deg, #c0392b, #e74c3c); border-color: #c0392b; padding: 5px 12px; border-radius: 8px; color: white; display: flex; align-items: center; gap: 5px; height: 40px; white-space: nowrap;">🎰 GADDAR RULET</button>

                        <!-- [NEW] Switch to Wheel Button (Host Only) - Compact Text Version -->
                        <button id="wr-switch-wheel-btn" class="gaddar-btn hidden" title="Şans Çarkına Geç" style="margin-right: 10px; font-size: 0.75rem; font-weight: 800; background: linear-gradient(135deg, #9b59b6, #8e44ad); border-color: #8e44ad; padding: 5px 12px; border-radius: 8px; color: white; display: flex; align-items: center; gap: 5px; height: 40px; white-space: nowrap;">🎡 ŞANS ÇARKİ</button>

                        <div id="wr-category-container">
                             <!-- Host için Select, Misafir için Badge -->
                             <select id="wr-category-select" class="gaddar-select mini hidden">
                                <option value="karisik">KARIŞIK</option>
                                <option value="tarih">TARİH</option>
                                <option value="cografya">COĞRAFYA</option>
                                <option value="psikoloji">PSİKOLOJİ</option>
                                <option value="sosyoloji">SOSYOLOJİ</option>
                                <option value="edebiyat">EDEBİYAT</option>
                                <option value="fen_bilimleri">FEN BİLİMLERİ</option>
                                <option value="siyaset">SİYASET</option>
                                <option value="din">DİN</option>
                                <option value="sinema">SİNEMA</option>
                                <option value="spor">SPOR</option>
                                <option value="gundem">GÜNDEM</option>
                                <option value="mitoloji">MİTOLOJİ</option>
                             </select>
                         <span id="wr-category-badge" class="badge">Kategori: ...</span>
                        </div>
                        <span id="wr-player-count">0/0</span>
                    </div>
                </div>

                <!-- [NEW] Settings Detail Panel (For Host/Guest) -->
                <div class="wr-settings-bar glass-panel">
                    <div class="setting-item">
                        <span class="s-label">MOD:</span>
                        <select id="wr-mode-select" class="gaddar-select mini hidden">
                            <option value="quiz">KLASİK BİLGİ</option>
                            <option value="wheel">ŞANS ÇARKİ</option>
                            <option value="roulette">🎰 GADDAR RULET</option>
                        </select>
                        <span id="wr-mode-badge" class="badge">KLASİK BİLGİ</span>
                    </div>

                    <div class="setting-item">
                        <span class="s-label">SÜRE:</span>
                        <select id="wr-time-select" class="gaddar-select mini hidden">
                            <option value="15">15s</option>
                            <option value="20" selected>20s</option>
                            <option value="30">30s</option>
                            <option value="45">45s</option>
                        </select>
                        <span id="wr-time-badge" class="badge">20s</span>
                    </div>

                    <div class="setting-item">
                        <span class="s-label">KAPASİTE:</span>
                        <select id="wr-max-players-select" class="gaddar-select mini hidden">
                            <option value="2">2 Kişi</option>
                            <option value="3">3 Kişi</option>
                            <option value="4">4 Kişi</option>
                        </select>
                        <span id="wr-max-players-badge" class="badge">4 Kişi</span>
                    </div>

                    <div class="setting-item">
                        <span class="s-label">GİZLİLİK:</span>
                        <select id="wr-privacy-select" class="gaddar-select mini hidden">
                            <option value="public">AÇIK</option>
                            <option value="private">GİZLİ</option>
                        </select>
                        <span id="wr-privacy-badge" class="badge">AÇIK</span>
                    </div>
                </div>

                <!-- Main Content: Split View -->
                <div class="wr-main">
                    <!-- Left: Players & Chat/Log -->
                    <div class="wr-sidebar glass-panel">
                        <h3>OYUNCULAR</h3>
                        <ul id="connected-players" class="wr-player-list">
                            <!-- Populated via JS -->
                        </ul>

                        <div class="wr-controls">
                            <!-- Host Button -->
                            <button id="lobby-start-game-btn" class="gaddar-btn hidden" disabled aria-label="Oyunu Başlat">OYUNU BAŞLAT</button>
                            <!-- Guest Button -->
                            <button id="lobby-ready-btn" class="gaddar-btn hidden" aria-label="Hazır Ol">HAZIR OL</button>
                            
                            <p class="wr-hint" id="wr-status-text" aria-live="polite">Oyuncu bekleniyor...</p>
                        </div>
                    </div>

                    <!-- Right: Wheel Area (Only in Wheel Mode) -->
                    <div id="wr-wheel-area" class="wr-wheel-container hidden">
                         <div class="wr-wheel-wrapper">
                            <!-- LEFT: Wheel -->
                            <div class="wheel-section-left">
                                <div class="wheel-container large">
                                    <div class="wheel-pointer">▼</div>
                                    <canvas id="wr-wheel-canvas"></canvas>
                                    <div class="wheel-center">
                                        <button id="wr-spin-btn">ÇEVİR</button>
                                    </div>
                                </div>
                            </div>

                            <!-- RIGHT: Results -->
                            <div class="wheel-section-right glass-panel">
                                <h2 id="wr-spin-result-text">ÇARK MODU</h2>
                                
                                <div class="collected-list-container">
                                    <h3>SEÇİLENLER</h3>
                                    <div id="wr-collected-categories-list" class="slots-grid">
                                        <!-- Categories appear here after spin -->
                                    </div>
                                </div>

                                <div class="wr-controls" style="margin-top: 1.5rem; display: flex; flex-direction: column; gap: 10px;">
                                    <!-- [REMOVED] Auto spin removed as requested -->
                                </div>
                            </div>
                         </div>
                    </div>
                </div>
            </div>
        </div>
`;
